import { Table, Button, Divider } from 'antd/lib';
import React from 'react';

class TablaArticulos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.articulos,
      textoBuscarNombre: '',
      filtered: false,
    };
  }

  render() {
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        sortOrder: 'ascend',
        sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              onClick={() =>
                this.props.history.push(`/admin/otros/articulos/${record._id}`)
              }
            >
              Editar
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { articulos } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={false}
        dataSource={articulos}
        title={() => <h2 style={{ textAlign: 'center' }}> Articulos </h2>}
        locale={{
          emptyText: 'No hay articulos cargados',
        }}
      />
    );
  }
}

export default TablaArticulos;
